import PropTypes from 'prop-types'
import { useMemo, useRef } from 'react'
import { useSelector } from 'react-redux'
import { Legend } from '../../../../../../../common/chart/legend'
import { PieChartTwoLevelContainer } from '../../../../../../../common/chart/pieChart/PieChartTwoLevelContainer'
import { Element } from '../../../../../../../common/html/element'
import { Notification } from '../../../../../../../common/notification'
import { getUnique } from '../../../../../../../helpers/common'
import { formatText, valToPercent } from '../../../../../../../helpers/value'
import { selectBreakdownCompare } from '../../../../store/slice'

export const PieChartTwoLevelComponent = ({ filterTime }) => {
  const data = useSelector(selectBreakdownCompare)
  const chartId = useRef(getUnique())
  const locale = useSelector((state) => state.i18n.locale)

  // Chuẩn hóa data cho inner/outer pie
  const arrColor = ['#006AA6', '#F49966', '#FF596A']
  const dataInner = useMemo(() => {
    if (!data?.baseData) return []
    const total = data?.baseData.reduce((sum, item) => sum + item.scoreValue, 0)
    const dataPercent = data?.baseData.map((item) => ({
      ...item,
      percent: item.scoreValue / total,
    }))
    return (
      dataPercent?.map((item, index) => ({
        name: formatText(item.riskDriverName),
        value: Number(item.percent),
        color: arrColor[index],
        period: filterTime.from?.label || '',
      })) || []
    )
  }, [data])

  const dataOuter = useMemo(() => {
    if (!data?.compareData) return []
    const total = data?.compareData.reduce(
      (sum, item) => sum + item.scoreValue,
      0,
    )
    const dataPercent = data?.compareData.map((item) => ({
      ...item,
      percent: item.scoreValue / total,
    }))
    return (
      dataPercent?.map((item, index) => ({
        name: formatText(item.riskDriverName),
        value: Number(item.percent),
        color: arrColor[index],
        period: filterTime.to?.label || '',
      })) || []
    )
  }, [data])

  if (!dataInner.length && !dataOuter.length)
    return (
      <div className="dFlex justifyContentCenter" style={{ height: 300 }}>
        <Notification />
      </div>
    )
  return (
    <div
      className="mt2 dBlock alignItemsCenter gap2"
      id="scoreBreakdownChartId"
    >
      {dataInner.filter((item) => item.value > 0).length ? (
        <div
          className="dFlex justifyContentCenter"
          style={{
            fontWeight: 600,
            fill: '#000000',
          }}
        >
          {filterTime.from?.label || ''}
        </div>
      ) : null}
      <div className="dFlex justifyContentCenter mb4">
        <PieChartTwoLevelContainer
          chartId={chartId.current}
          dataInner={dataInner}
          dataOuter={dataOuter}
          width={250}
          height={250}
          innerPieProps={{ innerRadius: 35, outerRadius: 75 }}
          outerPieProps={{ innerRadius: 75, outerRadius: 120 }}
          renderCustomTooltip={({ payload }) => {
            const item = payload?.[0]?.payload?.payload
            if (item) {
              return (
                <Element style={{ color: '#ECECEC' }}>
                  {item?.name}
                  <br />
                  {item?.period}
                  <br />
                  {valToPercent(item?.value, locale, false, true)}
                </Element>
              )
            }
          }}
          labelCenter={{
            title: filterTime.to?.label || '',
            style: {
              fontWeight: 600,
              fill: '#000000',
            },
          }}
        />
      </div>
      <Legend
        chartId={chartId.current}
        className="dFlex justifyContentCenter gap4 mb2"
        items={dataInner.map((item, index) => ({
          isI18n: false,
          title: item.name,
          color: item.color,
          pieIndex: index,
        }))}
      />
    </div>
  )
}

PieChartTwoLevelComponent.propTypes = {
  data: PropTypes.array,
}
